export const PROJECT_SETUP_STEP_STATUS = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
  SKIPPED: "SKIPPED",
};
